import { AUTH_API } from "./common_api";
const API_BASE = AUTH_API;

export async function loginAPI(email, password) {
  const fd = new FormData();
  fd.append("email", email);
  fd.append("password", password);

  const res = await fetch(`${API_BASE}/login`, {
    method: "POST",
    body: fd,
  });

  return res.json();
}

export async function sendForgotOtpAPI(email) {
  const fd = new FormData();
  fd.append("email", email);

  const res = await fetch(`${API_BASE}/forgot_password`, {
    method: "POST",
    body: fd,
  });

  return res.json();
}

export async function verifyOtpAPI(email, otp) {
  const fd = new FormData();
  fd.append("email", email);
  fd.append("otp", otp);

  const res = await fetch(`${API_BASE}/verify_otp`, {
    method: "POST",
    body: fd,
  });

  return res.json();
}

export async function resetPasswordAPI(email, otp, newPass) {
  const fd = new FormData();
  fd.append("email", email);
  fd.append("otp", otp);
  fd.append("new_password", newPass);

  const res = await fetch(`${API_BASE}/reset_password`, {
    method: "POST",
    body: fd,
  });

  return res.json();
}
